/**
 * Data Layer — sole interface to window.dataLayer.
 *
 * All analytics modules push events through this module.
 * No other module should write to window.dataLayer directly.
 */

/**
 * Push a virtual pageview event to the data layer.
 *
 * @param {string} url  — Full URL of the page
 * @param {string} title — Document title
 */
export function pushPageView(url, title) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'virtual_pageview',
        page: {
            url,
            title,
            path: new URL(url, location.origin).pathname,
        },
    });
}

/**
 * Push a generic event to the data layer.
 *
 * Built-in event names: cta_click, form_submit, outbound_click,
 * scroll_depth, element_view.
 *
 * Client projects use this for custom tracking:
 * @example
 * import { pushEvent } from './analytics/datalayer.js';
 * pushEvent('video_play', { videoId: '123' });
 *
 * @param {string} eventName — Event name (snake_case, GA4 convention)
 * @param {Object} [params={}] — Event-specific parameters
 */
export function pushEvent(eventName, params = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: eventName,
        ...params,
    });
}

/**
 * Check if the user has consented to a tracking category.
 *
 * Default stub — returns true for all categories.
 * GTM loads unconditionally in the default configuration.
 *
 * To add GDPR consent:
 * 1. Replace this function to read from your consent manager
 *    (CookieYes, Termly, OneTrust, etc.)
 * 2. Update Alpine.store('consent') defaults to { analytics: false, marketing: false }
 * 3. Wire your consent banner to update the Alpine store on acceptance
 * 4. Add a watcher in gtm.js to load GTM when consent changes
 *
 * @param {string} _category — Consent category ('analytics' or 'marketing')
 * @returns {boolean} Whether consent is granted
 */
export function hasConsent(_category) {
    return true;
}
